<mat-accordion>
    <div class="form_sections" *ngFor="let v of quote.vehicles; let i = index">
        <mat-expansion-panel [expanded]="i == 0">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>
                        <u>
                            <span>Vehicle</span>
                        </u>
                    </h4>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
                <div class="col-md-10">
                    <div class="row mb-3">
                        <div class="col-md-4 text-white"><label>Cover Limit:</label></div>
                        <div class="col-md-8">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text dark-green-bg text-white">&pound;</span>
                                </div>
                                <input type="text" name="vehicle_insurance_exc_ipt"
                                    [value]="getCoverLimitName(quote.excess_protect_cover_id)"
                                    class="form-control form-control-sm" readonly>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 text-white"><label>Registration Number:</label></div>
                        <div class="col-md-8">
                            <input type="text" name="registration_number" [value]="v.registration_number"
                                class="form-control form-control-sm" readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 text-white"><label>Model</label></div>
                        <div class="col-md-8">
                            <input type="text" name="model" [value]="v.model" class="form-control form-control-sm"
                                readonly>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-4 text-white"><label>Make</label></div>
                        <div class="col-md-8">
                            <input type="text" name="make" [value]="v.make" class="form-control form-control-sm"
                                readonly>
                        </div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </div>
</mat-accordion>